'use client';
import { useEffect, useState } from 'react';
import classNames from 'classnames';

interface ButtonBzProProps {
  label: string;
  proView?: string;
  url: string;
  variant?: 'trial' | 'with-arrow' | 'light';
}

export const ButtonBzPro = ({ label, proView = '', url, variant }: ButtonBzProProps) => {
  const [buttonLabel, setButtonLabel] = useState(label);
  const [buttonUrl, setButtonUrl] = useState(url);

  useEffect(() => {
    const userPermissions = localStorage.getItem('permissions');
    const proPermission = JSON.parse(userPermissions || '[]').find(
      perm => perm.action === 'bzpro/dashboard/open' && perm.effect === 'allow',
    );
    if (proPermission) {
      setButtonLabel('Launch Benzinga Pro');
      setButtonUrl(`https://pro.benzinga.com/dashboard/${proView ? proView : ''}`);
    }
  }, [label, proView, url]);

  return (
    <a
      aria-label={buttonLabel}
      className={classNames('whitespace-nowrap text-white', {
        'block py-2 rounded-sm bg-bzblue-600 text-center mx-2 md:mx-4 my-2': variant === 'trial',
        'bz-pro-btn': variant === 'with-arrow' || variant === 'light',
      })}
      href={buttonUrl}
    >
      {buttonLabel} {variant === 'with-arrow' && <span className="arrow">→</span>}
    </a>
  );
};
